@let alertsList = alertsList$ | async;
@let alertsEnabled = alertsEnabled$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Walking Farm&#174; Alerts</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  @if (alertsLoaded$ | async) {
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>
          {{ alertsFarmName$ | async | redDashIfEmpty }}
        </ion-label>
      </ion-list-header>
      <ion-item>
        <ion-icon
          [color]="alertsEnabled ? 'success' : 'medium'"
          [name]="alertsEnabled ? 'notifications-outline' : 'notifications-off-outline'"
          slot="start"
        ></ion-icon>
        <ion-label [color]="alertsEnabled ? 'success' : 'medium'">
          Farm Alerts {{ alertsEnabled ? 'On' : 'Off' }}
        </ion-label>
        <ion-toggle
          (click)="confirmToggle($event)"
          (ionChange)="toggleFarmAlertsEnabled($event)"
          color="success"
          slot="end"
          [checked]="alertsEnabled === true"
        ></ion-toggle>
      </ion-item>
      @if (alertsList && alertsList.length) {
        <ion-item>
          <ion-icon slot="start" color="medium" name="calendar-number-outline"></ion-icon>
          <ion-label color="medium"> Last Farm Alert </ion-label>
          <ion-note slot="end">{{ alertLastDate$ | async | date: 'MM/dd/yyyy' | redDashIfEmpty }}</ion-note>
        </ion-item>
      } @else {
        <ion-item>
          <ion-label color="medium">There are no farm alerts for this farm.</ion-label>
        </ion-item>
      }
      <ion-item
        color="primary"
        [button]="true"
        [detail]="false"
        [disabled]="!(unreadAlerts$ | async)?.length"
        (click)="markAllAlertsAsRead()"
      >
        <ion-label> Mark all alerts as read </ion-label>
        <ion-icon slot="end" name="checkmark-circle-outline"></ion-icon>
      </ion-item>
    </ion-list>
    @if (alertsList && alertsList.length) {
      <ion-list [inset]="true" class="no-last-line">
        <ion-accordion-group>
          @for (alert of alertsList; track alertsListTrackBy(i, alert); let i = $index) {
            <ion-item-divider>
              <ion-label color="medium" class="tw:h-4 tw:w-full">
                <span
                  class="tw:block tw:h-full tw:w-full tw:overflow-hidden tw:text-xs tw:text-ellipsis tw:whitespace-nowrap"
                >
                  {{ alert.address }}
                </span>
              </ion-label>
              <ion-button
                slot="end"
                fill="clear"
                [routerLink]="[
                  defaultBackHref ?? '/',
                  'walking-farm',
                  walkingFarmId,
                  'view',
                  'property',
                  alert.propertyNumber
                ]"
              >
                Details<ion-icon slot="end" name="arrow-forward-circle-outline"></ion-icon>
              </ion-button>
            </ion-item-divider>
            <ion-accordion value="{{ i }}">
              <ion-item slot="header" color="light" (click)="markAlertAsRead(alert)">
                <ion-icon
                  slot="start"
                  [color]="alert.isRead ? 'medium' : 'danger'"
                  name="notifications-circle-outline"
                ></ion-icon>
                <ion-label color="dark">
                  {{ alert.displayType | titlecase }}<br />
                  <ion-note color="medium" class="tw:text-xs tw:text-wrap">
                    {{ alert.date | date: 'MM/dd/yyyy' }}
                  </ion-note>
                </ion-label>
              </ion-item>
              <ion-list slot="content" lines="full">
                @for (data of alert.data; track data) {
                  @for (item of data | keyvalue; track item) {
                    <ion-item>
                      <ion-label color="medium">
                        {{ item.key }}<br />
                        <ion-note color="dark" class="tw:font-bold tw:text-wrap">
                          {{ item.value | redDashIfEmpty }}
                        </ion-note>
                      </ion-label>
                    </ion-item>
                  }
                }
              </ion-list>
            </ion-accordion>
          }
        </ion-accordion-group>
      </ion-list>
    }
  } @else {
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>
          <ion-skeleton-text [animated]="true" class="tw:w-2/3"></ion-skeleton-text>
        </ion-label>
      </ion-list-header>
      <ion-item>
        <ion-avatar slot="start">
          <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        </ion-avatar>
        <ion-label color="medium">
          <ion-skeleton-text [animated]="true" class="tw:w-full"></ion-skeleton-text>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label color="medium">
          <ion-skeleton-text [animated]="true" class="tw:w-2/3"></ion-skeleton-text
        ></ion-label>
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" class="no-last-line">
      <ion-accordion-group>
        @for (alert of [1, 2]; track alert; let i = $index) {
          <ion-item-divider>
            <ion-label color="medium">
              <span class="tw:text-xs">
                <ion-skeleton-text [animated]="true" class="tw:w-2/3"></ion-skeleton-text>
              </span>
            </ion-label>
            <ion-button [disabled]="true" slot="end" fill="clear">
              <ion-skeleton-text [animated]="true" class="tw:w-12"></ion-skeleton-text>
              <ion-icon slot="end" name="arrow-forward-circle-outline"></ion-icon>
            </ion-button>
          </ion-item-divider>
          <ion-accordion [disabled]="true" value="{{ i }}">
            <ion-item slot="header" color="light">
              <ion-avatar slot="start">
                <ion-skeleton-text [animated]="true"></ion-skeleton-text>
              </ion-avatar>
              <ion-label color="dark">
                <ion-skeleton-text [animated]="true" class="tw:w-2/3"></ion-skeleton-text><br />
                <ion-note color="medium" class="tw:text-xs tw:text-wrap">
                  <ion-skeleton-text [animated]="true" class="tw:w-2/3"></ion-skeleton-text> </ion-note
              ></ion-label>
            </ion-item>
          </ion-accordion>
        }
      </ion-accordion-group>
    </ion-list>
  }
</red-page-content>
